function sanitizeCustomsTeamForStorage(customsTeam) {
  if (!customsTeam || typeof customsTeam !== 'object') {
    return customsTeam;
  }
  const sanitized = { ...customsTeam };
  delete sanitized.users;
  delete sanitized.user;
  delete sanitized.teams;
  return sanitized;
}

function sanitizeCustomsTeamsValue(customsTeams) {
  if (customsTeams == null) {
    return customsTeams;
  }
  const list = Array.isArray(customsTeams) ? customsTeams : [customsTeams];
  const normalized = list.map(sanitizeCustomsTeamForStorage);
  return Array.isArray(customsTeams) ? normalized : normalized[0];
}

export function sanitizeCredentialsDataForStorage(data) {
  if (!data || typeof data !== 'object') {
    return null;
  }
  if (!data.person) {
    return data;
  }

  const person = { ...data.person };

  if (person.customsTeams != null) {
    person.customsTeams = sanitizeCustomsTeamsValue(person.customsTeams);
  }

  delete person.deskStates;

  return {
    ...data,
    person,
  };
}

export function sanitizeCredentialUserPayload(payload) {
  if (!payload || typeof payload !== 'object' || !payload.data) {
    return payload;
  }
  return {
    ...payload,
    data: sanitizeCredentialsDataForStorage(payload.data),
  };
}
